/**
 * 终端  0不限，1WEB端，2移动端，3PC端
 *
 */
export enum Terminal {
  不限 = 0,
  WEB端 = 1,
  移动端 = 2,
  PC端 = 3,
}

/**
 * 登录终端 1WEB端，2小程序端，3安卓端，4IOS端
 *
 */
export enum LoginTerminal {
  WEB端 = 1,
  小程序端 = 2,
  安卓端 = 3,
  IOS端 = 4,
}

/**
 * 设备终端
 */
export enum DeviceTerminal {
  WEB = 1,
  Android = 2,
  IOS = 3,
  PC = 4,
  微信 = 5,
}

/**
 * 用户类型
 */
export enum UserType {
  不限 = 0,
  平台用户 = 1,
  学生用户 = 2,
  实施用户 = 7,
}

/**
 * 登录认证类型
 */
export enum AuthenticationType {
  登录名密码 = 1,
  手机号密码 = 2,
  邮箱密码 = 3,
  微信 = 4,
  手机号验证码 = 5,
}

/**
 * 角色性质
 */
export enum RoleNature {
  自定义角色 = 2,
  系统角色 = 1,
}

/**
 * 发布状态
 */
export enum ReleaseOrNot {
  待发布 = 0,
  已发布 = 1,
}

/**
 * 功能层级
 */
export enum MenuLevel {
  一级菜单 = 1,
  二级菜单 = 2,
  三级菜单 = 3,
  四级菜单 = 4,
}

/**
 * 功能类型
 */
export enum MenuType {
  模块 = 1,
  页面 = 2,
  按钮 = 3,
}

/**
 * 功能性质
 */
export enum FunctionNature {
  系统 = 1,
  应用 = 2,
}

/**
 * 范围源
 */
export enum ScopeTable {
  组织 = 1,
}

/**
 * 用户主页类型
 */
export enum UserHomeType {
  首页 = 1,
  角色默认主页 = 2,
  自定义主页 = 3,
}

/**
 * 是否授权
 */
export enum AuthorizeFlag {
  否 = 0,
  是 = 1,
}

/**
 * 是否默认
 */
export enum DefaultFlag {
  否 = 0,
  是 = 1,
}

/**
 * 显示隐藏
 */
export enum ShowFlag {
  显示 = 1,
  隐藏 = 0,
}

/**
 * 数据字典code
 */
export enum DataDicCode {
  web登录页LOGO = 'webLoginLogo',
  适用场景 = 53,
  证件类型 = 45,
  证书类型 = 44,
  公司类型 = 43,
  民族 = 15,
  底部版权信息 = 258,
  Web首页LOGO = 233,
}

export enum SpecificRoute {
  NotFound = 'error-404',
}

export enum Service {
  基础服务 = 'base',
  文件服务 = 'file',
  认证服务 = 'auth',
  学习服务 = 'study',
}

/**
 * 1、H5网页跳转 2、小程序跳转
 */
export enum RedirectUrlType {
  H5跳转 = 1,
  小程序跳转 = 2,
}
